import FileInfo from './file-info.js';
import UploaderFile from './uploader-file.js';

interface FileChangeInfo extends FileInfo {
  allFiles: Array<UploaderFile>;
}

export default FileChangeInfo;
